import { render, staticRenderFns } from "./processing-select-ajax.vue?vue&type=template&id=678bd023&scoped=true&"
import script from "./processing-select-ajax.vue?vue&type=script&lang=js&"
export * from "./processing-select-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678bd023",
  null
  
)

export default component.exports